import React from 'react';
import CommonInput from '../Resusable/CommonInput';
import moment from 'moment';

const generateNewShippingDate = (
	dateOfShipping,
	minDate,
	maxDate,
	onChangeHandler,
	onErrorHandler
) => {
	let currentDate = new Date();
	let regxForDate = /^[\+]{1}[0-9]+$/;

	if (dateOfShipping === '.') {
		onChangeHandler(currentDate);
	} else if (regxForDate.test(dateOfShipping)) {
		let numberOfDaysToAdd = dateOfShipping.split('+');
		if (numberOfDaysToAdd.length >= 1) {
			let newShippingDate = new Date(currentDate);
			newShippingDate.setDate(
				newShippingDate.getDate() + parseInt(numberOfDaysToAdd[1])
			);
			if (
				moment(newShippingDate).subtract(1, 'days').isBefore(moment(maxDate))
			) {
				onChangeHandler(newShippingDate);
			} else {
				onChangeHandler('');
			}
		}
	} else {
		if (
			dateOfShipping.length &&
			moment(dateOfShipping).isSameOrAfter(
				moment(minDate).format('DD MMM YYYY')
			) &&
			moment(dateOfShipping).isSameOrBefore(
				moment(maxDate).format('DD MMM YYYY')
			)
		) {
			onChangeHandler(moment(dateOfShipping, "DD MMM YYYY").toDate());
		} else {
			if (onErrorHandler) onErrorHandler();
		}
	}
};

const AppCalendar = ({
	value,
	onChangeHandler,
	onFocusHandler,
	placeholder,
	minDate,
	maxDate,
	disabled,
	onErrorHandler,
	className,
	setMultiComponentFlightDateError,
	componentIndex,
	label,
	id = 'calendar-input',
	error
}) => {
	const handleBlur = (e) => {
		e.preventDefault();
		const inputValue = e.target.value;

		if (inputValue && inputValue.length) {
			generateNewShippingDate(
				inputValue,
				minDate,
				maxDate,
				onChangeHandler,
				onErrorHandler
			);
		} else {
			if (onErrorHandler) onErrorHandler();
		}

		if (
			setMultiComponentFlightDateError &&
			componentIndex !== undefined
		) {
			setMultiComponentFlightDateError(
				'FLIGHT_DATE',
				inputValue,
				componentIndex
			);
		}
	};

	return (
		<CommonInput
			type="calendar"
			value={value}
			onChange={(e) => {
				onChangeHandler(e.value);
				if (
					setMultiComponentFlightDateError &&
					componentIndex !== undefined
				) {
					setMultiComponentFlightDateError(
						'FLIGHT_DATE',
						e.value,
						componentIndex
					);
				}
			}}
			onFocus={onFocusHandler}
			onBlur={handleBlur}
			placeholder={placeholder}
			minDate={minDate}
			maxDate={maxDate}
			disabled={disabled}
			className={className}
			label={label}
			id={id}
			error={error}
		/>
	);
};

export default AppCalendar;